import store from '@/store';
import { normalizeNameWithOptions } from './normalizeNameWithOptions';

/**
 * Normalizes primary first-name fields while optionally preserving hyphens.
 * @param {string} input - Raw first-name input from the form.
 * @returns {string} Sanitized first-name value.
 */
export default function normalizeFirstName(input) {
  const { features } = store.getState().whitelabelConfig;

  return normalizeNameWithOptions(input, {
    removeAccents: !features.SUPPORT_FOR_ORTHOGRAPHIC_ACCENTS_ON_PASSENGERS,
    allowHyphen: features.ALLOW_HYPHEN_IN_NAME_FIELDS,
  });
}
